<div class="switch-container" [style.flex-direction]="isRow ? 'row' : 'column'"
[style.align-items]="isRow ? 'center' : 'flex-start'">
  <!-- Main Label -->
  <label
    [for]="id"
    class="form-label"
    *ngIf="title"
    [translatable]="{
      transKey: labelTranslationKey,
      modEnum: labelTranslationModuleEnum
    }"
  >
    {{ title }}
    <span [ngClass]="{ 'astrix-red': isRequired, 'no-astrix': !isRequired }"> *</span>
  </label>

  <!-- Toggle Switch -->
  <div class="toggle-switch">
    <input
      type="checkbox"
      [id]="id"
      class="toggle-input"
      [checked]="value"
      [disabled]="isDisabled || loading"
      (change)="sendValue($event)"
    />
    <label
      [for]="id"
      class="toggle-label"
      [class.loading]="loading"
    ></label>
  </div>

  <!-- Supporting Label -->
  <label
    *ngIf="label"
    class="label"
    [translatable]="{
      transKey: labelTranslationKey,
      modEnum: labelTranslationModuleEnum
    }"
  >
    {{ label }}
  </label>
</div>
